import { render, staticRenderFns } from "./errorRecordList.vue?vue&type=template&id=177fd2c8&scoped=true"
import script from "./errorRecordList.vue?vue&type=script&lang=js"
export * from "./errorRecordList.vue?vue&type=script&lang=js"
import style0 from "./errorRecordList.vue?vue&type=style&index=0&id=177fd2c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "177fd2c8",
  null
  
)

export default component.exports